import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 640 640">
        <path d="M317.638 140.163L640 262.113l-25.229 10.051v87.38c6.85 4.334 11.434 12.283 11.434 21.39 0 13.748-10.453 24.885-23.351 24.885-12.91 0-23.386-11.137-23.386-24.886 0-9.106 4.606-17.055 11.457-21.39v-77.906l-41.162 16.37v61.536c6.838 4.335 11.445 12.284 11.445 21.39 0 13.749-10.477 24.886-23.375 24.886-12.897 0-23.35-11.137-23.35-24.886 0-9.106 4.582-17.055 11.433-21.39v-52.04l-208.278 82.868L0 265.892l317.638-125.73zm-186.569 202.42l190.113 72.922 185.388-72.922v157.254H131.069V342.583z" />
    </SvgIcon>
);
